import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import { CSVLink } from "react-csv";
import 'jspdf-autotable';
import SiteLogs from './SiteLogs';
import SiteGradingLogEntries from './SiteGradingLogEntries';
import SiteLotStabilizationLogEntries from './SiteLotStabilizationLogEntries';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';

export default function SiteLogsContainer({ siteGradingLogsData, siteLotStabilizationLogsData, siteGradingLogEntriesData, siteLotStabilizationLogEntriesData, onShowEntries, closeLogEntries, sectionName, sectionIcon, site }) {
    const [selectedLog, setSelectedLog] = useState();
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });

    function handlePrintLogList() {
        let headerText = sectionName;
        let tableSelector = "#logList";
        let tableId = tableSelector.replace("#", "");
        let table = document.getElementById(tableId);
        table.classList.add("print");

        const doc = new jsPDF({ orientation: 'p', unit: 'px', format: 'a4', });
        doc.setTextColor(40, 68, 90);
        doc.setFont(undefined, 'bold');

        let finalY = 0;
        doc.text(headerText, 33, finalY + 40);
        doc.autoTable({
            html: tableSelector,
            theme: 'plain',
            startY: finalY + 50,
            headStyles: { lineWidth: { bottom: .25 }, textColor: '#28445a' },
            bodyStyles: { lineWidth: { bottom: .25 } },
        });

        // finalY = doc.lastAutoTable.finalY;

        table.classList.remove("print");

        doc.save('name-name.pdf');
    }

    function handlePrintEntries() {
        let headerText = `${sectionName} Entries: ${selectedLog.description}`;
        let tableSelector = "#logEntries";
        let tableId = tableSelector.replace("#", "");
        let table = document.getElementById(tableId);
        table.classList.add("print");

        const doc = new jsPDF({ orientation: 'l', unit: 'px', format: 'a4', });
        doc.setTextColor(40, 68, 90);
        doc.setFont(undefined, 'bold');

        let finalY = 0;
        doc.text(site.siteName, 33, finalY + 22);
        doc.text(headerText, 33, finalY + 40);
        doc.autoTable({
            html: tableSelector,
            theme: 'plain',
            startY: finalY + 50,
            headStyles: { lineWidth: { bottom: .25 }, textColor: '#28445a' },
            bodyStyles: { lineWidth: { bottom: .25 } },
        });

        // finalY = doc.lastAutoTable.finalY;

        table.classList.remove("print");

        doc.save(`${site.siteName}-${sectionName}.pdf`);
    }

    function handleShowGradingLogEntries(id) {
        let log = siteGradingLogsData.logs.find(x => x.id === id);
        setSelectedLog(log);
        onShowEntries(id);
    }

    function handleShowLotStabilizationLogEntries(id) {
        let log = siteLotStabilizationLogsData.logs.find(x => x.id === id);
        setSelectedLog(log);
        onShowEntries(id);
    }

    function handleCloseLogEntries() {
        setSelectedLog();
        closeLogEntries();
    }

    let buttonContainer;
    let siteGradingLogs;
    if (siteGradingLogsData !== undefined) {
        siteGradingLogs = siteGradingLogsData.loading && "Loading";
        if (siteGradingLogsData.loading === false && siteGradingLogsData.logs) {
            siteGradingLogs = (<SiteLogs
                logs={siteGradingLogsData.logs}
                onShowEntries={handleShowGradingLogEntries}
                hide={siteGradingLogEntriesData !== undefined}
            />);
        }
        // buttonContainer = (<div className="buttonContainer flexbox-flex justify-between"><button onClick={handlePrintLogList}>Print</button></div>);
    }

    let siteGradingLogEntries;
    if (siteGradingLogEntriesData !== undefined) {
        siteGradingLogEntries = siteGradingLogEntriesData.loading && "Loading";
        let csvData = [];
        let csvHeaders = [
            { label: "Date Activity Initiated", key: "activityStarted" },
            { label: "Activity Description", key: "description" },
            { label: "Activity Location", key: "location" },
            { label: "Date Activity Ceased", key: "activityEnded" },
            { label: "Date Stabilization Measure Initiated", key: "stabilizationStarted" },
            { label: "Stabilization Measure Description", key: "stableDescription" },
            // { label: "Ownership Date", key: "ownershipDate" },
        ];

        if (siteGradingLogEntriesData.loading === false && siteGradingLogEntriesData.logs) {
            siteGradingLogEntries = (<SiteGradingLogEntries
                logTypeName={selectedLog?.description}
                logs={siteGradingLogEntriesData.logs}
                onPrint={handlePrintEntries}
                onCloseLogEntries={handleCloseLogEntries} />);

            csvData = siteGradingLogEntriesData.logs.map(log => ({
                activityStarted: log.activityStarted ? dateFormatter.format(new Date(log.activityStarted)) : "",
                description: log.description,
                location: log.location,
                activityEnded: log.activityEnded ? dateFormatter.format(new Date(log.activityEnded)) : "",
                stabilizationStarted: log.stabilizationStarted ? dateFormatter.format(new Date(log.stabilizationStarted)) : "",
                stableDescription: log.stableDescription,
                // ownershipDate: log.ownershipDate ? dateFormatter.format(new Date(log.ownershipDate)) : "",
            }));
        }
        buttonContainer = (<div className="buttonContainer flexbox-flex justify-between">
            <div className="flex gap-x-1">
                <button onClick={handlePrintEntries}>Print</button>
                <CSVLink data={csvData} headers={csvHeaders} filename={`${site.siteName}-${sectionName}.csv`} className="button" target="_blank">Export</CSVLink>
            </div>
            <button onClick={handleCloseLogEntries}>Done</button>
        </div>);
    }

    let siteLotStabilizationLogs;
    if (siteLotStabilizationLogsData !== undefined) {
        siteLotStabilizationLogs = siteLotStabilizationLogsData.loading && "Loading";
        if (siteLotStabilizationLogsData.loading === false && siteLotStabilizationLogsData.logs) {
            siteLotStabilizationLogs = (<SiteLogs
                logs={siteLotStabilizationLogsData.logs}
                onShowEntries={handleShowLotStabilizationLogEntries}
                hide={siteLotStabilizationLogEntriesData !== undefined}
            />);
        }
        // buttonContainer = (<div className="buttonContainer flexbox-flex justify-between"><button onClick={handlePrintLogList}>Print</button></div>);
    }

    let siteLotStabilizationLogEntries;
    if (siteLotStabilizationLogEntriesData !== undefined) {
        siteLotStabilizationLogEntries = siteLotStabilizationLogEntriesData.loading && "Loading";
        let csvData = [];
        let csvHeaders = [
            { label: "Lot Number", key: "lotNumber" },
            { label: "Date of Temporary Stabilization", key: "tempStabilizationDate" },
            { label: "Date of Active Construction", key: "activeConstructionDate" },
            { label: "Final Stabilization Date", key: "finalStabilizationDate" },
            { label: "Date of Ownership", key: "ownershipDate" },
            { label: "Comments", key: "comments" },
        ];

        if (siteLotStabilizationLogEntriesData.loading === false && siteLotStabilizationLogEntriesData.logs) {
            siteLotStabilizationLogEntries = (<SiteLotStabilizationLogEntries
                logTypeName={selectedLog?.description}
                logs={siteLotStabilizationLogEntriesData.logs}
                onPrint={handlePrintEntries}
                onCloseLogEntries={handleCloseLogEntries} />);

            csvData = siteLotStabilizationLogEntriesData.logs.map(log => ({
                lotNumber: log.lotNumber,
                tempStabilizationDate: log.tempStabilizationDate ? dateFormatter.format(new Date(log.tempStabilizationDate)) : "",
                activeConstructionDate: log.activeConstructionDate ? dateFormatter.format(new Date(log.activeConstructionDate)) : "",
                finalStabilizationDate: log.finalStabilizationDate ? dateFormatter.format(new Date(log.finalStabilizationDate)) : "",
                ownershipDate: log.ownershipDate ? dateFormatter.format(new Date(log.ownershipDate)) : "",
                comments: log.comments
            }));
        }
        buttonContainer = (<div className="buttonContainer flexbox-flex justify-between">
            <div className="flex gap-x-1">
                <button onClick={handlePrintEntries}>Print</button>
                <CSVLink data={csvData} headers={csvHeaders} filename={`${site.siteName}-${sectionName}.csv`} className="button" target="_blank">Export</CSVLink>
            </div>
            <button onClick={handleCloseLogEntries}>Done</button>
        </div>);
    }

    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} truncateName={true} classes="" />
        <div className="logsContainer">
            {siteGradingLogs}
            {siteGradingLogEntries}
            {siteLotStabilizationLogs}
            {siteLotStabilizationLogEntries}
        </div>
        {buttonContainer}
    </>);
}